"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChatMessageUtils_1 = require("./ChatMessageUtils");
class ChatMessageDto {
    constructor(cmDto) {
        this.id = "";
        this.timeStamp = 0;
        this.belongToChatId = "";
        this.speaker = "";
        this.recipient = ""; //接收者，目前為了與Web.Client相容先留著，之後不會用到
        this.text = "";
        this.contentType = "";
        this._thumbnailChecker = async () => false;
        this._thumbnailSupplier = async () => new Blob();
        this._attachmentChecker = async () => false;
        this._attachmentSupplier = async () => new Blob();
        if (cmDto) {
            this.id = cmDto.id || this.id;
            this.timeStamp = cmDto.timeStamp || this.timeStamp;
            this.belongToChatId = cmDto.belongToChatId || this.belongToChatId;
            this.speaker = cmDto.speaker || this.speaker;
            this.recipient = cmDto.recipient || this.recipient;
            this.text = cmDto.text || this.text;
            this.contentType = cmDto.contentType || this.contentType;
            this._thumbnailChecker = cmDto.thumbnailChecker || this._thumbnailChecker;
            this._thumbnailSupplier = cmDto.thumbnailSupplier || this._thumbnailSupplier;
            this._attachmentChecker = cmDto.attachmentChecker || this._attachmentChecker;
            this._attachmentSupplier = cmDto.attachmentSupplier || this._attachmentSupplier;
        }
    }
    IsText() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeText(this.contentType); }
    IsImage() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeImage(this.contentType); }
    IsAudio() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeAudio(this.contentType); }
    IsContentTypeWithThumbnail() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeWithThumbnail(this.contentType); }
    ThumbnailName() {
        return this.IsContentTypeWithThumbnail() ? ChatMessageUtils_1.ChatMessageUtils.ThumbnailName(this.text) :
            "";
    }
    HasThumbnailAsync() { return ChatMessageUtils_1.ChatMessageUtils.HasContentAsync(this._thumbnailChecker, this._thumbnailSupplier); }
    GetThumbnailAsync() { return ChatMessageUtils_1.ChatMessageUtils.GetContentAsync(this._thumbnailSupplier); }
    InjectThumbnailSupplier(checker, supplier) {
        this._thumbnailChecker = checker;
        this._thumbnailSupplier = supplier;
    }
    get thumbnailChecker() { return this._thumbnailChecker; }
    get thumbnailSupplier() { return this._thumbnailSupplier; }
    IsContentTypeWithAttachment() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeWithAttachment(this.contentType); }
    AttachmentName() { return this.IsContentTypeWithAttachment() ? this.text : ""; }
    HasAttachmentAsync() { return ChatMessageUtils_1.ChatMessageUtils.HasContentAsync(this._attachmentChecker, this._attachmentSupplier); }
    GetAttachmentAsync() { return ChatMessageUtils_1.ChatMessageUtils.GetContentAsync(this._attachmentSupplier); }
    InjectAttachmentSupplier(checker, supplier) {
        this._attachmentChecker = checker;
        this._attachmentSupplier = supplier;
    }
    get attachmentChecker() { return this._attachmentChecker; }
    get attachmentSupplier() { return this._attachmentSupplier; }
}
ChatMessageDto.INVALID_CHAT_MESSAGE = new ChatMessageDto();
exports.ChatMessageDto = ChatMessageDto;
//# sourceMappingURL=ChatMessageDto.js.map